const css = `@keyframes _panelIn_1rip5_1 {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes _panelOut_1rip5_1 {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(8px);
  }
}
@keyframes _pulse_1rip5_1 {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
@keyframes _highlightIn_1rip5_1 {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
._panel_1rip5_39 {
  width: 320px;
  max-height: 420px;
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.08);
  overflow: hidden;
  z-index: 100001;
  animation: _panelIn_1rip5_1 0.15s ease-out forwards;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
}
._panel_1rip5_39._exiting_1rip5_53 {
  animation: _panelOut_1rip5_1 0.12s ease-out forwards;
}

._header_1rip5_57 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._titleWrapper_1rip5_65 {
  display: flex;
  align-items: center;
  gap: 8px;
}

._title_1rip5_65 {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

._badge_1rip5_77 {
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.8);
}
._badge_1rip5_77._hasCritical_1rip5_85 {
  background: rgba(255, 59, 48, 0.2);
  color: #ff3b30;
}
._badge_1rip5_77._hasSerious_1rip5_89 {
  background: rgba(255, 149, 0, 0.2);
  color: #ff9500;
}

._runButton_1rip5_94 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 5px 10px;
  background: rgba(60, 130, 247, 0.2);
  border: none;
  border-radius: 6px;
  color: #3c82f7;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._runButton_1rip5_94:hover:not(:disabled) {
  background: rgba(60, 130, 247, 0.3);
}
._runButton_1rip5_94:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
._runButton_1rip5_94 svg {
  width: 12px;
  height: 12px;
}

._controls_1rip5_121 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._filterSelect_1rip5_129 {
  flex: 1;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 12px;
  padding: 6px 10px;
  cursor: pointer;
  outline: none;
}
._filterSelect_1rip5_129:hover {
  background: rgba(255, 255, 255, 0.12);
}
._filterSelect_1rip5_129:focus {
  box-shadow: 0 0 0 2px rgba(60, 130, 247, 0.4);
}
._filterSelect_1rip5_129 option {
  background: #1a1a1a;
  color: #fff;
}

._recordButton_1rip5_151 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._recordButton_1rip5_151:hover {
  background: rgba(255, 255, 255, 0.12);
}
._recordButton_1rip5_151._recording_1rip5_168 {
  background: rgba(255, 59, 48, 0.2);
  color: #ff3b30;
}

._recordingDot_1rip5_173 {
  width: 6px;
  height: 6px;
  background: #ff3b30;
  border-radius: 50%;
  animation: _pulse_1rip5_1 1.5s ease-in-out infinite;
}

._clearButton_1rip5_181 {
  padding: 6px 10px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
._clearButton_1rip5_181:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.9);
}
._clearButton_1rip5_181:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

._recordingControls_1rip5_200 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: rgba(255, 59, 48, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._recordingIndicator_1rip5_209 {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #ff3b30;
  font-weight: 500;
}

._captureButton_1rip5_218 {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: rgba(255, 59, 48, 0.2);
  border: none;
  border-radius: 6px;
  color: #ff3b30;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._captureButton_1rip5_218:hover {
  background: rgba(255, 59, 48, 0.3);
}
._captureButton_1rip5_218 svg {
  width: 12px;
  height: 12px;
}

._content_1rip5_241 {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}
._content_1rip5_241::-webkit-scrollbar {
  width: 6px;
}
._content_1rip5_241::-webkit-scrollbar-track {
  background: transparent;
}
._content_1rip5_241::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}
._content_1rip5_241::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

._empty_1rip5_260 {
  padding: 24px 14px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
}

._emptyIcon_1rip5_267 {
  font-size: 24px;
  margin-bottom: 8px;
}

._issueGroup_1rip5_272 {
  padding: 6px;
}

._groupHeader_1rip5_276 {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.6);
}

._groupCount_1rip5_288 {
  font-weight: 500;
  padding: 1px 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
}

._issueItem_1rip5_295 {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._issueItem_1rip5_295:hover {
  background: rgba(255, 255, 255, 0.06);
}
._issueItem_1rip5_295:active {
  background: rgba(255, 255, 255, 0.1);
}

._impactDot_1rip5_311 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
}
._impactDot_1rip5_311._critical_1rip5_318 {
  background: #ff3b30;
}
._impactDot_1rip5_311._serious_1rip5_321 {
  background: #ff9500;
}
._impactDot_1rip5_311._moderate_1rip5_324 {
  background: #ffcc00;
}
._impactDot_1rip5_311._minor_1rip5_327 {
  background: #3c82f7;
}

._issueContent_1rip5_331 {
  flex: 1;
  min-width: 0;
}

._issueHelp_1rip5_336 {
  font-size: 12px;
  color: #fff;
  line-height: 1.4;
}

._issueSelector_1rip5_342 {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.5);
  margin-top: 2px;
  font-family: "SF Mono", Monaco, "Consolas", monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._issueLink_1rip5_352 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  text-decoration: none;
}
._issueLink_1rip5_352:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #3c82f7;
}
._issueLink_1rip5_352 svg {
  width: 14px;
  height: 14px;
}

._recordedStates_1rip5_376 {
  padding: 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

._recordedStatesHeader_1rip5_381 {
  padding: 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.6);
}

._recordedState_1rip5_376 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
._recordedState_1rip5_376:hover {
  background: rgba(255, 255, 255, 0.06);
}
._recordedState_1rip5_376._active_1rip5_402 {
  background: rgba(60, 130, 247, 0.15);
}

._stateName_1rip5_406 {
  flex: 1;
  font-size: 12px;
  color: #fff;
}

._stateCount_1rip5_412 {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
}

._highlightOverlay_1rip5_420 {
  position: fixed;
  inset: 0;
  z-index: 99997;
  pointer-events: none;
}

@keyframes _highlightPulse_1rip5_1 {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.85;
    transform: scale(1.02);
  }
}
._highlight_1rip5_420 {
  position: fixed;
  border-radius: 4px;
  pointer-events: none;
  box-sizing: border-box;
  animation: _highlightIn_1rip5_1 0.12s ease-out forwards;
  transition: opacity 0.2s ease, border-width 0.15s ease, box-shadow 0.2s ease;
}
._highlight_1rip5_420._critical_1rip5_318 {
  border: 2px dashed rgba(255, 59, 48, 0.5);
  background: rgba(255, 59, 48, 0.06);
}
._highlight_1rip5_420._serious_1rip5_321 {
  border: 2px dashed rgba(255, 149, 0, 0.5);
  background: rgba(255, 149, 0, 0.06);
}
._highlight_1rip5_420._moderate_1rip5_324 {
  border: 2px dashed rgba(255, 204, 0, 0.5);
  background: rgba(255, 204, 0, 0.06);
}
._highlight_1rip5_420._minor_1rip5_327 {
  border: 2px dashed rgba(60, 130, 247, 0.5);
  background: rgba(60, 130, 247, 0.06);
}
._highlight_1rip5_420._hovered_1rip5_461 {
  z-index: 1;
  animation: _highlightIn_1rip5_1 0.12s ease-out forwards, _highlightPulse_1rip5_1 1.5s ease-in-out 0.12s infinite;
}
._highlight_1rip5_420._hovered_1rip5_461._critical_1rip5_318 {
  border: 3px solid #ff3b30;
  background: rgba(255, 59, 48, 0.15);
  box-shadow: 0 0 0 4px rgba(255, 59, 48, 0.2), 0 0 20px rgba(255, 59, 48, 0.3);
}
._highlight_1rip5_420._hovered_1rip5_461._serious_1rip5_321 {
  border: 3px solid #ff9500;
  background: rgba(255, 149, 0, 0.15);
  box-shadow: 0 0 0 4px rgba(255, 149, 0, 0.2), 0 0 20px rgba(255, 149, 0, 0.3);
}
._highlight_1rip5_420._hovered_1rip5_461._moderate_1rip5_324 {
  border: 3px solid #ffcc00;
  background: rgba(255, 204, 0, 0.15);
  box-shadow: 0 0 0 4px rgba(255, 204, 0, 0.2), 0 0 20px rgba(255, 204, 0, 0.3);
}
._highlight_1rip5_420._hovered_1rip5_461._minor_1rip5_327 {
  border: 3px solid #3c82f7;
  background: rgba(60, 130, 247, 0.15);
  box-shadow: 0 0 0 4px rgba(60, 130, 247, 0.2), 0 0 20px rgba(60, 130, 247, 0.3);
}

._spinner_1rip5_486 {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(60, 130, 247, 0.3);
  border-top-color: #3c82f7;
  border-radius: 50%;
  animation: _spin_1rip5_486 0.8s linear infinite;
}

@keyframes _spin_1rip5_486 {
  to {
    transform: rotate(360deg);
  }
}
._srOnly_1rip5_500 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {"panel":"_panel_1rip5_39","panelIn":"_panelIn_1rip5_1","exiting":"_exiting_1rip5_53","panelOut":"_panelOut_1rip5_1","header":"_header_1rip5_57","titleWrapper":"_titleWrapper_1rip5_65","title":"_title_1rip5_65","badge":"_badge_1rip5_77","hasCritical":"_hasCritical_1rip5_85","hasSerious":"_hasSerious_1rip5_89","runButton":"_runButton_1rip5_94","controls":"_controls_1rip5_121","filterSelect":"_filterSelect_1rip5_129","recordButton":"_recordButton_1rip5_151","recording":"_recording_1rip5_168","recordingDot":"_recordingDot_1rip5_173","pulse":"_pulse_1rip5_1","clearButton":"_clearButton_1rip5_181","recordingControls":"_recordingControls_1rip5_200","recordingIndicator":"_recordingIndicator_1rip5_209","captureButton":"_captureButton_1rip5_218","content":"_content_1rip5_241","empty":"_empty_1rip5_260","emptyIcon":"_emptyIcon_1rip5_267","issueGroup":"_issueGroup_1rip5_272","groupHeader":"_groupHeader_1rip5_276","groupCount":"_groupCount_1rip5_288","issueItem":"_issueItem_1rip5_295","impactDot":"_impactDot_1rip5_311","critical":"_critical_1rip5_318","serious":"_serious_1rip5_321","moderate":"_moderate_1rip5_324","minor":"_minor_1rip5_327","issueContent":"_issueContent_1rip5_331","issueHelp":"_issueHelp_1rip5_336","issueSelector":"_issueSelector_1rip5_342","issueLink":"_issueLink_1rip5_352","recordedStates":"_recordedStates_1rip5_376","recordedStatesHeader":"_recordedStatesHeader_1rip5_381","recordedState":"_recordedState_1rip5_376","active":"_active_1rip5_402","stateName":"_stateName_1rip5_406","stateCount":"_stateCount_1rip5_412","highlightOverlay":"_highlightOverlay_1rip5_420","highlight":"_highlight_1rip5_420","highlightIn":"_highlightIn_1rip5_1","hovered":"_hovered_1rip5_461","highlightPulse":"_highlightPulse_1rip5_1","spinner":"_spinner_1rip5_486","spin":"_spin_1rip5_486","srOnly":"_srOnly_1rip5_500"};